import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DxButtonModule, DxChartModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxDateRangeBoxModule, DxFormModule, DxHtmlEditorModule, DxLoadIndicatorModule, DxLoadPanelModule, DxLookupModule, DxNumberBoxModule, DxPopupModule, DxProgressBarModule, DxSelectBoxModule, DxSwitchModule, DxTagBoxModule, DxTextAreaModule, DxTextBoxModule } from 'devextreme-angular';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiClientService as ApiClientService } from '../services/api-client.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PonudeComponent } from './ponude/ponude.component';
import { AuthInterceptor } from '../services/auth.interceptor';
import { CreatePonudaComponent } from './ponude/create/create-ponuda.component';
import { CacheService } from '../services/cache.service';
import { EditPonudaComponent } from './ponude/edit/edit-ponuda.component';
import { PotraznjeComponent } from './potraznje/potraznje.component';
import { CreatePotraznjaComponent } from './potraznje/create/create-potraznja.component';
import { EditPotraznjaComponent } from './potraznje/edit/edit-potraznja.component';
import { AuthGuard } from '../services/auth.guard';
import { UserService } from '../services/user.service';
import { UserStatusService } from '../services/user-status.service';
import { ArtikliComponent } from './artikli/artikli.component';
import { JediniceMjereComponent } from './jedinice-mjere/jedinice-mjere.component';
import { OpisiComponent } from './opisi/opisi.component';
import { PoslovniImenikComponent } from './poslovni-imenik/poslovni-imenik.component';
import { FirmeComponent } from './firme/firme.component';
import { KretanjeCijenaComponent } from './kretanje-cijena/kretanje-cijena.component';
import { DxoValueAxisModule } from 'devextreme-angular/ui/nested';
import { KretanjeCijenaPdfComponent } from './kretanje-cijena-pdf/kretanje-cijena-pdf.component';
import { ProduzeciSaradnjeComponent } from './produzeci-saradnje/produzeci-saradnje.component';
import { DjelatnostiFirmeComponent } from './djelatnosti-firme/djelatnosti-firme.component';
import { OblastiFirmeComponent } from './oblasti-firme/oblasti-firme.component';
import { StatusiFirmeComponent } from './statusi-firme/statusi-firme.component';
import { GradoviComponent } from './gradovi/gradovi.component';
import { DrzaveComponent } from './drzave/drzave.component';
import { ObavjestenjaComponent } from './obavjestenja/obavjestenja.component';
import { KontaktiComponent } from './kontakti/kontakti.component';
import { KorisniciComponent } from './korisnici/korisnici.component';
import { PregledIpComponent } from './pregled-ip/pregled-ip.component';
import { MobilnePonudeComponent } from './mobile/mobilne-ponude/mobilne-ponude.component';
import { CreateMobilnaPonudaComponent } from './mobile/mobilne-ponude/create/create-mobilna-ponuda.component';
import { MobilnePotraznjeComponent } from './mobile/mobilne-potraznnje/mobilne-potraznje.component';
import { CreateMobilnaPotraznjaComponent } from './mobile/mobilne-potraznnje/create/create-mobilna-potraznja.component';
import { KursEuraComponent } from './mobile/kurs-eura/kurs-eura.component';
import { CreateKursEuraComponent } from './mobile/kurs-eura/create/create-kurs-eura.component';
import { NudjeneCijeneComponent } from './mobile/nudjene-cijene/nudjene-cijene.component';
import { CreateNudjeneCijeneComponent } from './mobile/nudjene-cijene/create/create-nudjene-cijene.component';
import { RealizacijeComponent } from './mobile/realizacije/realizacije.component';
import { CreateRealizacijeComponent } from './mobile/realizacije/create/create-realizacije.component';
import { OtkupneCijeneComponent } from './mobile/otkupne-cijene/otkupne-cijene.component';
import { CreateOtkupneCijeneComponent } from './mobile/otkupne-cijene/create/create-otkupne-cijene.component';
import { VaznaObavjestenjaComponent } from './mobile/vazna-obavjestenja/vazna-obavjestenja.component';
import { CreateVaznaObavjestenjaComponent } from './mobile/vazna-obavjestenja/create/create-vazna-obavjestenja.component';
import { RegistrovaniKontaktComponent } from './mobile/poruke-registrovanih/registrovani-kontakt.component';
import { AnonimniKontaktComponent } from './mobile/poruke-anonimnih/anonimni-kontakt.component';
import { CijeneInoComponent } from './cijene-ino/cijene-ino.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    DashboardComponent,
    PonudeComponent,
    CreatePonudaComponent,
    EditPonudaComponent,
    PotraznjeComponent,
    CreatePotraznjaComponent,
    EditPotraznjaComponent,
    ArtikliComponent,
    JediniceMjereComponent,
    OpisiComponent,
    PoslovniImenikComponent,
    FirmeComponent,
    KretanjeCijenaComponent,
    KretanjeCijenaPdfComponent,
    ProduzeciSaradnjeComponent,
    DjelatnostiFirmeComponent,
    OblastiFirmeComponent,
    StatusiFirmeComponent,
    GradoviComponent,
    DrzaveComponent,
    ObavjestenjaComponent,
    KontaktiComponent,
    KorisniciComponent,
    PregledIpComponent,
    MobilnePonudeComponent,
    CreateMobilnaPonudaComponent,
    MobilnePotraznjeComponent,
    CreateMobilnaPotraznjaComponent,
    KursEuraComponent,
    CreateKursEuraComponent,
    NudjeneCijeneComponent,
    CreateNudjeneCijeneComponent,
    RealizacijeComponent,
    CreateRealizacijeComponent,
    OtkupneCijeneComponent,
    CreateOtkupneCijeneComponent,
    VaznaObavjestenjaComponent,
    CreateVaznaObavjestenjaComponent,
    RegistrovaniKontaktComponent,
    AnonimniKontaktComponent,
    CijeneInoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DxProgressBarModule,
    DxChartModule,
    DxoValueAxisModule,
    DxCheckBoxModule,
    DxSwitchModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxLoadPanelModule,
    DxButtonModule,
    DxDateRangeBoxModule,
    DxSelectBoxModule,
    DxPopupModule,
    DxFormModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    DxDateBoxModule,
    DxLookupModule,
    DxHtmlEditorModule,
    ReactiveFormsModule,
    DxLoadIndicatorModule,
    DxTagBoxModule,
    NgbCarouselModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [ApiClientService, CacheService, AuthGuard, UserService, UserStatusService, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
